export default __webpack_public_path__ + "static/media/blueDownloadArrow.2dde3e0c.svg";